const turno = document.querySelector('#turno_comensais')
const manha = document.querySelector('#comensais_manha')
const tarde = document.querySelector('#comensais_tarde')
const noite = document.querySelector('#comensais_noite')

const hideElement = el => el.style.display = 'none'
const showElement = el => el.style.display = ''

if (manha) {
  hideElement(manha);
}

if (tarde) {
  hideElement(tarde);
}

if (noite) {
  hideElement(noite);
}

if (turno) {
  turno.addEventListener('change', e => {
    limparCampos();
    if (e.target.value == 'manha') {
      showElement(manha);
      hideElement(tarde);
      hideElement(noite);
    } else if (e.target.value == 'tarde') {
      showElement(tarde);
      hideElement(manha);
      hideElement(noite);
    } else if (e.target.value == 'noite') {
      showElement(noite);
      hideElement(manha);
      hideElement(tarde);
    }
  });
}


function limparCampos() {
  document.getElementById('desje').value = '';
  document.getElementById('cafe_litro_m').value = '';
  document.getElementById('leite_litro_m').value = '';
  document.getElementById('xtudo_m').value = '';
  document.getElementById('xtudo_refri_m').value = '';
  document.getElementById('hextra_m').value = '';
  document.getElementById('almoco').value = '';
  document.getElementById('cafe_t').value = '';
  document.getElementById('cafe_litro_t').value = '';
  document.getElementById('leite_litro_t').value = '';
  document.getElementById('xtudo_t').value = '';
  document.getElementById('xtudo_refri_t').value = '';
  document.getElementById('hextra_t').value = '';
  document.getElementById('jantar').value = '';
  document.getElementById('cafe_n').value = '';
  document.getElementById('cafe_litro_n').value = '';
  document.getElementById('leite_litro_n').value = '';
  document.getElementById('xtudo_n').value = '';
  document.getElementById('xtudo_refri_n').value = '';
  document.getElementById('hextra_n').value = '';
  document.getElementById('ceia').value = '';
}
